import React from 'react';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import ModalOuterContainer from '../containers/ModalOuterContainer';

const ConfirmModal = ({
    title = '',
    message = 'Are you sure?',
    handleSubmit,
    isPosting,
}) => {
    return (
        <ModalOuterContainer handleSubmit={handleSubmit} isPosting={isPosting}>
            <div className="description">
                {title !== '' && <Typography tag="h1">{title}</Typography>}
                <Typography>{message}</Typography>
            </div>
        </ModalOuterContainer>
    );
};

export default ConfirmModal;
